import React, { useMemo } from 'react';
import { sections } from './data/onboarding';
import { useScrollSpy } from './hooks/useScrollSpy';
import { useScrollProgress } from './hooks/useScrollProgress';
import { useProgress } from './hooks/useProgress';
import { Hero } from './components/Hero';
import { SectionNav } from './components/SectionNav';
import { SectionCard } from './components/SectionCard';
import { StepList } from './components/StepList';
import { TourAreas } from './components/TourAreas';
import { TogetherPanel } from './components/TogetherPanel';
import { ExploreGrid } from './components/ExploreGrid';
import { NeedAHand } from './components/NeedAHand';
import { ScreenshotDump } from './components/ScreenshotDump';
import { Reveal } from './components/Reveal';
const togetherIntro: Record<string, string> = {
  'ai-knowledge-base': 'Your Voice AI receptionist answers callers using a knowledge base about your business — so it sounds like someone who actually works for you. We build this with you.',
  'ai-agent-number': 'Your Voice AI runs on its own dedicated phone number and answers 24/7, so nothing rings out. We set up the number and the agent with you.'
};
export function App() {
  const ids = useMemo(() => [...sections.map(section => section.id), 'need-a-hand'], []);
  const activeId = useScrollSpy(ids);
  const scrollProgress = useScrollProgress();
  const {
    done,
    isDone,
    toggle
  } = useProgress();
  return <div className="min-h-full w-full bg-[#0a0a0a] text-white" data-id="element-0" data-mp="2zmemy5wtxg6g">
      <Hero data-id="element-1" data-mp="33m5a7zn5de68" />

      <div className="mx-auto flex w-full max-w-6xl flex-col px-0 pb-20 sm:pb-28 lg:flex-row lg:gap-10 lg:px-8 lg:pt-12" data-id="element-2" data-mp="33lx18iu5at0b">
        <SectionNav sections={sections} activeId={activeId} isDone={isDone} doneCount={done.filter(id => id !== 'need-a-hand').length} scrollProgress={scrollProgress} data-id="element-3" data-mp="38k6uup081ljt" />

        <main className="min-w-0 flex-1 space-y-5 px-5 pt-8 sm:space-y-6 sm:px-8 lg:px-0 lg:pt-0" data-id="element-4" data-mp="nxwvvh10nctl">
          {sections.map(section => <Reveal key={section.id} data-id="element-5" data-mp="35oxut5vn8u6">
              <SectionCard section={section} done={isDone(section.id)} onToggleDone={() => toggle(section.id)} tone={section.kind === 'white-glove' ? 'together' : 'default'} data-id="element-6" data-mp="34ncnvv5d5yq">
                {section.kind === 'tour' && <>
                    {section.steps && <StepList steps={section.steps} data-id="element-7" data-mp="3gkv0trn63pda" />}
                    {section.areas && <TourAreas areas={section.areas} data-id="element-8" data-mp="3gj1rg4l66r1l" />}
                  </>}

                {section.kind === 'white-glove' && section.togetherPoints && <TogetherPanel intro={togetherIntro[section.id] ?? ''} points={section.togetherPoints} data-id="element-9" data-mp="3qcimtd0yge7d" />}

                {section.kind === 'explore' && section.items && <ExploreGrid items={section.items} data-id="element-10" data-mp="2swbsjc44bcl7" />}

                {section.kind === 'steps' && section.steps && <StepList steps={section.steps} data-id="element-11" data-mp="18c6p87f6dygh" />}
              </SectionCard>
            </Reveal>)}

          <Reveal className="pt-2" data-id="element-12" data-mp="1d6axcu06gcj5">
            <NeedAHand data-id="element-13" data-mp="ygd25u3tymkg" />
          </Reveal>

          <Reveal className="pt-2" data-id="element-14" data-mp="yheq2z5y33jl">
            <ScreenshotDump data-id="element-15" data-mp="13eevr8yvu4a6" />
          </Reveal>
        </main>
      </div>
    </div>;
}